import type { Membership, Workspace } from '@buakei/types';

/**
 * DEMO PERSONAS — fictitious accounts for the persona switcher (ADR-004 D).
 * No credentials. Replaced by Firebase Authentication in M2-01.
 */
export type DemoPersona = {
  id: string;
  displayName: string;
  description: string;
  memberships: Membership[];
};

export const DEMO_WORKSPACES: Workspace[] = [
  { id: 'ws_personal_demo', kind: 'personal', name: 'Personal practice' },
  {
    id: 'ws_firm_demo',
    kind: 'firm',
    name: 'Demonstration Chambers (fictitious)',
    organizationId: 'org_demo_chambers',
  },
  { id: 'ws_learning_demo', kind: 'learning', name: 'My study space' },
];

/** Console memberships are not data workspaces; their authorisation model arrives in M3. */
const EDITORIAL_CONSOLE = 'console_editorial';
const OPERATIONS_CONSOLE = 'console_operations';

export const DEMO_PERSONAS: DemoPersona[] = [
  {
    id: 'solo-lawyer',
    displayName: 'Demo Solo Lawyer',
    description: 'Independent practitioner with a personal Professional workspace.',
    memberships: [{ workspaceId: 'ws_personal_demo', roles: ['lawyer'], matterGrants: [] }],
  },
  {
    id: 'associate-student',
    displayName: 'Demo Associate',
    description: 'Firm associate who is also studying — holds Professional and Learning access.',
    memberships: [
      {
        workspaceId: 'ws_firm_demo',
        organizationId: 'org_demo_chambers',
        roles: ['lawyer'],
        matterGrants: [],
      },
      { workspaceId: 'ws_learning_demo', roles: ['student'], matterGrants: [] },
    ],
  },
  {
    id: 'firm-admin',
    displayName: 'Demo Firm Administrator',
    description: 'Manages firm members. Has no automatic access to matter content.',
    memberships: [
      {
        workspaceId: 'ws_firm_demo',
        organizationId: 'org_demo_chambers',
        roles: ['firm_admin'],
        matterGrants: [],
      },
    ],
  },
  {
    id: 'student',
    displayName: 'Demo Law Student',
    description: 'Learning workspace only.',
    memberships: [{ workspaceId: 'ws_learning_demo', roles: ['student'], matterGrants: [] }],
  },
  {
    id: 'legal-editor',
    displayName: 'Demo Legal Editor',
    description: 'Reviews public legal sources. No access to client matters.',
    memberships: [{ workspaceId: EDITORIAL_CONSOLE, roles: ['legal_editor'], matterGrants: [] }],
  },
  {
    id: 'support-agent',
    displayName: 'Demo Support Agent',
    description: 'Account and billing support. No access to client content.',
    memberships: [{ workspaceId: OPERATIONS_CONSOLE, roles: ['support_agent'], matterGrants: [] }],
  },
];
